import { yupResolver } from "@hookform/resolvers/yup";
import { FC, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Box, FormHelperText } from "@mui/material";
import { MDTypography } from "../../../../../Component/Common/Components/MDTypography";
import { Quill } from "../../../../../Component/Common/Components/Quill/Quill";
import { seniorManagersSchema } from "./SeniorManagersValidation";
import { SeniorManagersService } from "../../../../../Component/Api/EmploymentEquity/Plan/SeniorManagers/SeniorManagersService";
import { SeniorManagersDto } from "../../../../../Component/Model/Dto/EmploymentEquity/Plan/EESeniorManagers";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import { EEScorecardAtom } from "../../../../../State/EEScorecard.Atom";
import { ConsolidationAtom } from "../../../../../State/Consolidation.Atom";

interface IProps {
    scorecardId : string;
}

type InputForm = {
    detail?: string;
}

export const SeniorManagers: FC<IProps> = (props) => {

    const scorecard = useRecoilValue(EEScorecardAtom);
    const isConsolidatedScorecard = useRecoilValue(ConsolidationAtom);
    const maxConsolidatedDetailLength = 3000 * (scorecard.ConsolidationSourceScorecardsCount ?? 1);
    const maxDetailLength = isConsolidatedScorecard ? maxConsolidatedDetailLength : 3000;
    const [remainingSeniorManagerCharacters, setRemainingSeniorManagerCharacters] = useState(maxDetailLength);

    
    const { control, reset, getValues, setValue, formState: { errors } } = useForm<InputForm>({
        mode: 'all',
        resolver: yupResolver(seniorManagersSchema(maxDetailLength))
    });

    const getSeniorManagersData = async (scorecardId: string) => {
        try {
            const dataResponse = await SeniorManagersService.GetSeniorManagersInformation(scorecardId);
            const formData: InputForm = {
                detail: dataResponse.data.detail
            }
            reset(formData);
        } catch (error: any) {
            console.log(error);
        }
    }

    const saveSeniorManagersForm = async () => {
        const formData = getValues();

        seniorManagersSchema(maxDetailLength).validate(formData, { abortEarly: false }).then(async() => {
            const requestData: SeniorManagersDto.SeniorManagersDto = {
                scorecardId: props.scorecardId,
                detail: formData.detail
            }
            const response = await SeniorManagersService.SaveSeniorManagersInformation(requestData);
        }).catch(function (error: any) {
            toast.error(error.message);
        });
    }
    
    useEffect(() => {
        getSeniorManagersData(props.scorecardId);

        return () => {
            if (localStorage.getItem('coreToken') !== null) {
                saveSeniorManagersForm();
            }
        }
    }, [props.scorecardId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box component="form" mt={2}>
            <Box>
                <MDTypography
                    variant='button'
                    fontWeight='regular'
                    style={{ color: !!errors.detail ? 'error' : '#666666', fontSize: "0.85em" }}
                >
                    Detail* (Max {maxDetailLength} characters)
                </MDTypography>
                <Controller
                    control={control}
                    name="detail"
                    render={({ field: { onChange, value } }) => (
                        <Quill
                            initialContent={value || ""}
                            maxLength={maxDetailLength}
                            handleChange={(newValue: string) => {
                                onChange(newValue);
                                setValue('detail', newValue);
                            }}
                            setRemainingCharacters={setRemainingSeniorManagerCharacters}
                        />
                    )}
                />
                <MDTypography
                    variant="button"
                    fontWeight="regular"
                    style={{  color:
                        remainingSeniorManagerCharacters < 0
                        ? "#FF0000" 
                        : "#666666", 
                        fontSize: "0.85em"
                    }}
                >
                    {remainingSeniorManagerCharacters} characters remaining
                </MDTypography>
                {(!!errors.detail) && <FormHelperText error>{errors.detail?.message}</FormHelperText>}
            </Box>
        </Box>
    )
}